import { render } from "./SuccessSave.vue?vue&type=template&id=5747ca45&ts=true"
import script from "./SuccessSave.vue?vue&type=script&lang=ts"
export * from "./SuccessSave.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__